import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoResolver implements Resolve<any> {
  constructor(private translocoService: TranslocoService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<any> {
    const scopes: string[] = route.data?.['translocoScopes'] || [];

    if (scopes.length === 0) {
      return of(true); // no scopes to load
    }

    const loaders = scopes.map(scope =>
      this.translocoService.load(scope).pipe(catchError(() => of({})))
    );

    return forkJoin(loaders);
  }
}
